import React from "react";

import WPHeading from "../../../../../../../packages/WPHeading";

import { CheckIcon } from "../../../../../../../assets/icons";

import "./UserLicenseListSection.scss";

const UserLicenseListSection = ({
  title,
  licenseSectionData,
  id,
  isCompact = false,
}) => {
  if (!licenseSectionData || licenseSectionData.length === 0) return null;
  const headingSize = isCompact ? "xxSmall" : "small";
  return (
    <div className="user-license-list-section" id={id}>
      <WPHeading text={title} size={headingSize} secondary id={`${id}-title`} />
      <div className="user-license-list">
        {licenseSectionData.map((item, idx) => (
          <div
            className="user-license-list-item"
            key={`${item.name}-${idx}`}
            id={`${id}-item-${idx}`}
          >
            <CheckIcon />
            <WPHeading
              text={item.name}
              size={headingSize}
              secondary
              type="default"
              className="user-license-item-heading"
              id={`${id}-item-label-${idx}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserLicenseListSection;
